import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.flags.js";
import ApprenticePeriodStep from './apprentice-period-step.vue';
import PracticeAreaStep from './practice-area-step.vue';
import { useApiErrorToast } from '@/modules/useApiErrorToast';
import { useRepositories } from '@/plugins/repositories';
import { useStore } from '@/store/useStore';
import { useTelemetry } from '@/plugins/telemetry';
import { useAuth } from '@/plugins/auth';
var stringToNumber = function stringToNumber(numString) {
  if (numString === '') return null;
  var numberedString = Number(numString);
  if (isNaN(numberedString)) return null;
  return numberedString;
};
export default defineComponent({
  components: {
    ApprenticePeriodStep: ApprenticePeriodStep,
    PracticeAreaStep: PracticeAreaStep
  },
  setup: function setup() {
    var route = useRoute();
    var repositories = useRepositories();
    var telemetry = useTelemetry();
    var store = useStore();
    var _useApiErrorToast = useApiErrorToast(),
      showRetriableErrorToast = _useApiErrorToast.showRetriableErrorToast;
    var canSkipInputProfile = ref(true);
    var loadingMe = ref(true);
    var _useAuth = useAuth(),
      user = _useAuth.user;
    canSkipInputProfile.value = user.flags.canSkipInputProfile;
    loadingMe.value = false;
    var step = ref(1);
    var organizationType = ref(null);
    var apprenticePeriod = ref('');
    var apprenticePeriodLabel = computed(function () {
      var _stringToNumber;
      return (_stringToNumber = stringToNumber(apprenticePeriod.value)) !== null && _stringToNumber !== void 0 ? _stringToNumber : '未入力';
    });
    var practices = ref([{
      practiceId: -1
    }]);
    var practicesSummary = ref(['']);
    var loadingOrganizationType = ref(true);
    repositories.users.getOrganizationType().then(function (res) {
      organizationType.value = res;
      loadingOrganizationType.value = false;
    });
    var backToRedirectUrl = function backToRedirectUrl() {
      var redirectUrl = route.query['redirect_url'];
      if (!Array.isArray(redirectUrl) && redirectUrl) {
        // KLUDGE: to workaround `Redirected when going from "/profile/wizard?redirect_url=%2F" to "/" via a navigation guard` nuxt error
        // TODO: think of using router methods instead
        window.location.href = redirectUrl;
      } else {
        window.location.href = '/profile';
      }
    };
    var submit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return repositories.users.putUserProfile(stringToNumber(apprenticePeriod.value), practices.value);
            case 1:
              store.commit('setFirstAccessOfTheDay', false);
              backToRedirectUrl();
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              showRetriableErrorToast('プロフィールの送信に失敗しました');
              telemetry.sendErrorTelemetry(_t, route);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function submit() {
        return _ref.apply(this, arguments);
      };
    }();
    var skip = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return repositories.users.skipInputUserProfile();
            case 1:
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              // スキップに失敗した場合、翌日に再度表示されてしまうはずだが、当日の利用は問題ないためエラーをレポートするだけにする
              telemetry.sendErrorTelemetry(_t2, route);
            case 3:
              store.commit('setFirstAccessOfTheDay', false);
              backToRedirectUrl();
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }));
      return function skip() {
        return _ref2.apply(this, arguments);
      };
    }();
    var isLawOffice = computed(function () {
      return organizationType.value === 'law-office';
    });
    var isProfessionalOffice = computed(function () {
      return organizationType.value === 'professional-office';
    });
    var practiceLabel = computed(function () {
      return isLawOffice.value ? 'プラクティス' : '主なリサーチ分野';
    });
    var loading = computed(function () {
      return loadingMe.value || loadingOrganizationType.value;
    });
    return {
      submit: submit,
      canSkipInputProfile: canSkipInputProfile,
      skip: skip,
      step: step,
      apprenticePeriod: apprenticePeriod,
      apprenticePeriodLabel: apprenticePeriodLabel,
      practices: practices,
      practicesSummary: practicesSummary,
      isLawOffice: isLawOffice,
      isProfessionalOffice: isProfessionalOffice,
      practiceLabel: practiceLabel,
      loading: loading
    };
  }
});